export default __webpack_public_path__ + "static/media/r1.0e474267.jpg";